
import { defineComponent, PropType } from "vue";
import StopWacth from "./StopWacth.vue";
import TaskInterface from "@/interface/TaskInterface";
export default defineComponent({
  name: "Task-Component",
  components: { StopWacth },
  props: {
    completedTask: {
      type: Object as PropType<TaskInterface>,
      required: true,
    },
  },
});
